import { pathToRegexp } from 'path-to-regexp';
import PageTitle from 'types/PageTitle';

// see routes.rb
// see https://alltrails.atlassian.net/wiki/spaces/AH/pages/814776368/AllTrails+Pages+Page+Types#Explore-Pages
const getPageTitle = (pathname: any): string => {
  if (pathToRegexp('/:locale?/explore').test(pathname)) {
    return PageTitle.ExploreSearch;
  }

  if (pathToRegexp('/:locale?/explore/map/:map').test(pathname)) {
    return PageTitle.ExploreMap;
  }

  if (pathToRegexp('/:locale?/explore/map/:map/:details').test(pathname)) {
    return PageTitle.ExploreMapDetails;
  }

  if (pathToRegexp('/:locale?/explore/recording/:recording').test(pathname)) {
    return PageTitle.ExploreRecording;
  }

  if (pathToRegexp('/:locale?/explore/recording/:map/:details').test(pathname)) {
    return PageTitle.ExploreRecordingDetails;
  }

  if (pathToRegexp('/:locale?/explore/trail/(.*)').test(pathname)) {
    return PageTitle.ExploreTrail;
  }

  if (pathToRegexp('/:locale?/trail/(.*)').test(pathname)) {
    return PageTitle.TrailDetails;
  }

  if (pathToRegexp('/:locale?/explore/map/new').test(pathname)) {
    return PageTitle.CreateMap;
  }

  if (pathToRegexp('/:locale?/explore/list/:slug').test(pathname)) {
    return PageTitle.ExploreList;
  }

  if (pathToRegexp('/:locale?/members/:slug/recordings').test(pathname)) {
    return PageTitle.ActivitiesList;
  }

  if (pathToRegexp('/:locale?/members/:slug/maps').test(pathname)) {
    return PageTitle.MapsList;
  }

  return PageTitle.Unknown;
};

export { getPageTitle };
